import React, { Suspense } from "react";
import { lazyWithRetry } from "./lib/lazyWithRetry";
import ChunkErrorBoundary from "./components/ChunkErrorBoundary";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import CBCAppWrapper from "./CBCAppWrapper";
import { ViewModeProvider } from "./hooks/useViewMode";
import VoiceRecordingBar from "./components/VoiceRecordingBar";
import LogContactModal from "./components/customer360/LogContactModal";

// Signup + ERP are separate entry points — keep them out of the main bundle.
const CBCSignup = lazyWithRetry(() => import("./CBCSignup"));
const ErpApp = lazyWithRetry(() => import("./erp/ErpApp"));

const routeFallback = (
  <div className="min-h-screen grid place-items-center text-gray-600">Loading…</div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Register service worker for PWA install support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

root.render(
  <React.StrictMode>
    <ViewModeProvider>
    <BrowserRouter>
      <Routes>
        {/* Default home renders your wrapper normally */}
        <Route path="/" element={<CBCAppWrapper />} />

        {/* Direct routes to specific configurators */}
        <Route path="/order/faux2" element={<CBCAppWrapper initialProduct="faux" />} />
        <Route path="/order/vert35" element={<CBCAppWrapper initialProduct="vert" />} />
        <Route path="/order/roller" element={<CBCAppWrapper initialProduct="roll" />} />

        {/* Public signup */}
        <Route path="/signup" element={<ChunkErrorBoundary><Suspense fallback={routeFallback}><CBCSignup /></Suspense></ChunkErrorBoundary>} />

        {/* ERP (Macola replacement) — its own shell, staff with the `erp` page only */}
        <Route path="/erp/*" element={<ChunkErrorBoundary><Suspense fallback={routeFallback}><ErpApp /></Suspense></ChunkErrorBoundary>} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
    {/* Voice notes keep recording across screens; Stop from anywhere */}
    <VoiceRecordingBar />
    {/* One contact log for the whole site: stays open while the rep moves around */}
    <LogContactModal />
    </ViewModeProvider>
  </React.StrictMode>
);
